export enum HeaderDataTestIdEnum {
  HEADER_USER_BUTTON = 'header--user-button',
  HEADER_LOGIN_BUTTON = 'header--login-button',
  HEADER_I_WANT_TO_ORDER_BUTTON = 'header--i-want-to-order-button',
  HEADER_OUR_BRANCHES_BUTTON = 'header--our-branches-button',
  HEADER_FOR_YOU_NAVBAR_TITLE = 'header--for-you-navbar-title',
  HEADER_PROFESSIONAL_NAVBAR_TITLE = 'header--professional-navbar-title',
  HEADER_ABOUT_MEDPREV_NAVBAR_TITLE = 'header--about-medprev-navbar-title',
  HEADER_PARTNER_SYSTEM_LINK = 'header--partner-system-link',
  HEADER_BE_OUR_PARTNER_LINK = 'header--be-our-partner-link',
  HEADER_ABOUT_US_LINK = 'header--about-us-link',
  HEADER_NEED_HELP_LINK = 'header--need-help-link',
  HEADER_BLOG_LINK = 'header--blog-link',
  HEADER_WORK_WITH_US_LINK = 'header--work-with-us-link',
  HEADER_LINK_LOGO = 'header--link-logo',
  HEADER_HUMBURGER_BUTTON = 'hamburger-button',
}
